module.exports = __webpack_public_path__ + "img/p-sec01-img02.f0cc10ed.png";